module.exports = {"embedded":"true","defaultView":"Site Plan"}